export function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
}
export function resize(arr, size, defaultValue) {
    const resized = new Array(size).fill(defaultValue);
    for (let i = 0; i < Math.min(arr.length, size); i += 1) {
        resized[i] = arr[i];
    }
    return resized;
}
